<template>
  <!-- Widened container to give the review/payment step more breathing room -->
  <div class="container mx-auto p-6 max-w-6xl">
    <div class="bg-white shadow-md rounded-lg p-6">
      <h2 class="text-2xl font-semibold text-gray-800 mb-4">Create a Job Posting</h2>

      <!-- Multi-step Job Posting Form Component -->
      <JobForm 
        :jobUUID="jobUUID" 
        @job-submitted="handleJobSubmission" 
        @update-draft="updateDraft" 
      />
    </div>
  </div>
</template>
  
  <script>
  import JobForm from '@/components/marketplace/jobs/JobForm.vue';
  import companyService from '@/services/marketplace/company.service';
  import jobsService from '@/services/marketplace/jobs.service';

  export default {
    name: 'JobPosting',
    inject: ['toggleLoading'],
    components: {
      JobForm
    },
    data() {
      return {
          jobUUID: null,
          draft: null,
      }
    },
    methods: {
      async updateDraft(draft, step, billingModel) {
        // Post step, draft data and jobUUID to a function in jobs SERVICE
        try {
            await jobsService.updateDraft(step, draft, this.jobUUID, billingModel);
        } catch (error) {
            console.error('Failed to update draft:', error);
        }
      },
      handleJobSubmission(jobData) {
        this.toggleLoading(true);
        try {
            jobsService.postJob(jobData)
                .then(response => {
                    this.toggleLoading(false);
                    this.$root.notify('Your new job post has been successfully created.', 'success');
                    this.$router.push('/company/manage-jobs');
                })
                .catch(error => {
                    this.$root.notify('Something went wrong, please try again', 'error');
                    this.toggleLoading(false);
                });
        } catch (error) {
          this.toggleLoading(false);
        }
      },
      async generateDraft() {
          jobsService.generateDraft()
            .then(response => {
                this.jobUUID = response.data.uuid
            })
            .catch(error => {
                // Nothing really at this point
            })
      },
    },
    async mounted() {
        await this.generateDraft()
    }
  };
  </script>
  
  <style scoped>
  button {
    transition: all 0.3s ease;
  }
  </style>
  
